import React from 'react';

import LevelOfRisk from 'components/projectCoshh/components/LevelOfRisk';

function getCoshhDocumentDetails({
  comparisonValueForCustomValueUsage,
  coshhDocument,
  secondaryFieldPlaceholder,
  translations,
}) {
  const details = [
    {
      label: translations.labels.quantityOnSite,
      text: coshhDocument.quantityOnSite,
    },
    {
      label: translations.labels.quantityToBeUsed,
      text: coshhDocument.quantityToBeUsed,
    },
    {
      label: translations.labels.substanceQuantityPerDay,
      text: coshhDocument.substanceQuantityPerDay,
    },
    {
      label: translations.labels.uses,
      text:
        coshhDocument.uses === comparisonValueForCustomValueUsage ?
          coshhDocument.methodOfUseOther || secondaryFieldPlaceholder
        : coshhDocument.uses,
    },
    {
      label: translations.labels.staffNumber,
      text: coshhDocument.staffNumber,
    },
    {
      label: translations.labels.personsAtRisk,
      text: formatPersonsAtRisk({
        coshhDocument,
        comparisonValueForCustomValueUsage,
        secondaryFieldPlaceholder,
      }),
    },
    {
      label: translations.labels.workerExposureTime,
      text:
        (
          coshhDocument.workerExposureTime ===
          comparisonValueForCustomValueUsage
        ) ?
          coshhDocument.workerExposureTimeOther || secondaryFieldPlaceholder
        : coshhDocument.workerExposureTime,
    },
    {
      label: translations.labels.exposureFrequency,
      text:
        coshhDocument.exposureFrequency === comparisonValueForCustomValueUsage ?
          coshhDocument.exposureFrequencyOther || secondaryFieldPlaceholder
        : coshhDocument.exposureFrequency,
    },
    { label: translations.labels.location, text: coshhDocument.location },
    {
      label: translations.labels.levelOfRisk,
      text:
        coshhDocument.levelOfRisk ?
          <LevelOfRisk option={coshhDocument.levelOfRisk} />
        : '',
    },
    {
      label: translations.labels.additionalInformation,
      text: coshhDocument.additionalInformation,
    },
  ];

  return details;
}

function formatPersonsAtRisk({
  comparisonValueForCustomValueUsage,
  coshhDocument,
  secondaryFieldPlaceholder,
}) {
  if (!coshhDocument.personsAtRisk) return [];

  const personsAtRiskValues = coshhDocument.personsAtRisk.map(
    (personAtRisk) => personAtRisk.value,
  );

  const filteredPersonsAtRisk = personsAtRiskValues.filter(
    (personAtRisk) => personAtRisk !== comparisonValueForCustomValueUsage,
  );

  if (personsAtRiskValues.includes(comparisonValueForCustomValueUsage)) {
    filteredPersonsAtRisk.push(
      coshhDocument.personsAtRiskOther || secondaryFieldPlaceholder,
    );
  }

  return filteredPersonsAtRisk.join(', ');
}

export { getCoshhDocumentDetails };
